import React, { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import Call from '../_API/Call'

const List = React.memo(({ con, handleChange, removeSection, blocksOpen, openBlocks }) => {

	const [ cookies ] = useCookies(['role'])
	const [ items, setItems ] = useState((con.content.length) ? con.content.split('^') : [])
	const [ options ] = useState(con.options && con.options.length ? con.options : null)
	const [ tempValue, setTempValue ] = useState(false)
	const [ helperActive, setHelperActive ] = useState(false)
	const [ description, setDescription ] = useState('')

	const sendChange = (value) => {
		handleChange({
			id: con.id,
			type: con.type,
			name: con.name,
			description: con.description,
			content: value
		})
	}

	const addItem = e => {
		if (e.key === 'Enter') {
			let temp = items
			temp.push(e.target.value.trim())
			setItems(temp)
			sendChange(temp.join('^'))
			// Reset
			e.target.value = ''
			setTempValue(false)
		} else {
			setTempValue(true)
		}
	}

	const addItemFromSelect = e => {
		if (e.target.value) {
			let temp = items
			temp.push(e.target.value.trim())
			setItems(temp)
			sendChange(temp.join('^'))
			// Reset
			e.target.value = ''
			setTempValue(false)
		}
	}

	const removeItem = item => {
		let temp = items
		let index = temp.indexOf(item)
		temp.splice(index,1)
		setItems(temp)
		sendChange(temp.join('^'))
	}

	const helperToggle = () => {
		setHelperActive(!helperActive)
	}

	//---------------------
	//- If Chestertown RiverArts and program category
	//---------------------

	useEffect(() => {
		let location = window.location.href
		let str = 'chestertownriverarts.org/programs'
		if (location.indexOf(str) > -1 && con.name === 'Category') {
			(async function() {
				const cats = await Call('/cra/program-categories')
				setDescription('Current categories include ' + cats.categories.join(', '))
			})()
		}
	},[]) //eslint-disable-line

	return (
		<div className={(blocksOpen) ? 'ac-block ac-block-list active' : 'ac-block ac-block-list'} onClick={(e) => openBlocks(e)}>
			<h2><span>{con.id + 1}.</span> {con.name}
				<div className='title-helper'>
					<i className="far fa-question-circle" onClick={() => helperToggle()}></i>
					<p className={(helperActive) ? 'title-content active' : 'title-content'}>This is a text list element where you can add items by pressing Enter on the keyboard.</p>
				</div>
			</h2>
			<p className='acb-description'>{con.description}</p>
			{options &&
				<select onChange={(e) => addItemFromSelect(e)}>
					<option value=''>Select</option>
					{options.map((item, i) => {
						return <option value={item}>{item}</option>
					})}
				</select>
			}
			{!options &&
				<input onKeyUp={(e) => addItem(e)} />
			}
			{!options && tempValue &&
				<p className='list-temp-value'>Don't forget to add by pressing Enter.</p>
			}
			<div className='list'>
				{items.map((item, i) => {
					return <p key={i}>{item.trim()}
						<i className="fas fa-times" onClick={() => removeItem(item)}></i>
					</p>
				})}
			</div>
			{description &&
				<p className='description'>{description}</p>
			}
			{cookies.role === 'super' && con.id !== 0 && <i className="fas fa-times" onClick={() => removeSection(con.id)}/>}
		</div>
	)
})

export default List